import { render, staticRenderFns } from "./CommentOnHold.vue?vue&type=template&id=e51786c0&scoped=true&"
import script from "./CommentOnHold.vue?vue&type=script&lang=js&"
export * from "./CommentOnHold.vue?vue&type=script&lang=js&"
import style0 from "./CommentOnHold.vue?vue&type=style&index=0&id=e51786c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51786c0",
  null
  
)

export default component.exports